export default __webpack_public_path__ + "static/media/learose4-1440w.cc6fddb2.avif";